import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);


export const geoToAddress = (gi) => ({
  company_address: {
    address_line_1: gi?.address_info?.address_line_1 || "",
    address_line_2: gi?.address_info?.address_line_2 || "",
    address_line_3: gi?.address_info?.address_line_3 || "",
  },
  state_id: gi?.state_info?.state_id ?? null,
  state_name: gi?.state_info?.state_name || "",
  district_id: gi?.district_info?.district_id ?? null,
  district_name: gi?.district_info?.district_name || "",
  location_id: gi?.location_info?.location_id ?? null,
  location_name: gi?.location_info?.location_name || "",
  taluka_id: gi?.taluka_info?.taluka_id ?? null,
  taluka_name: gi?.taluka_info?.taluka_name || "",
  pincode: gi?.pincode_info?.pincode_id ?? null,
  pincode_name: gi?.pincode_info?.pincode_name || "",
});

export const pricingGeographyId = (gi) =>
  gi?.pricing_geography_info?.pricing_geography_id ?? null;

export const operationalDetailsToAddress = (od) => ({
  company_address: {
    address_line_1: od?.address_line_1 || "",
    address_line_2: od?.address_line_2 || "",
    address_line_3: "",
  },
  state_id: od?.state_id ?? null,
  state_name: od?.state_name || "",
  district_id: od?.district_id ?? null,
  district_name: od?.district_name || "",
  location_id: od?.location_id ?? null,
  location_name: od?.location_name || "",
  taluka_id: null,
  taluka_name: "",
  pincode: od?.pincode_id ?? null,
  pincode_name: "",
});

// True when an address object carries real content (used to decide whether a
// fetched registered address is usable, or we should fall back to operational).
export const isNonEmptyAddress = (addr) =>
  Boolean(
    addr?.company_address?.address_line_1 ||
      addr?.state_id ||
      addr?.district_id ||
      addr?.location_id ||
      addr?.pincode,
  );

export const emptyAddress = () => ({
  company_address: { address_line_1: "", address_line_2: "", address_line_3: "" },
  state_id: null,
  state_name: "",
  district_id: null,
  district_name: "",
  location_id: null,
  location_name: "",
  taluka_id: null,
  taluka_name: "",
  pincode: null,
  pincode_name: "",
});

export const toApiDob = (dob) => {
  if (!dob) return null;
  const d = dayjs(dob, ["YYYY-MM-DD", "DD-MM-YYYY"]);
  return d.isValid() ? d.format("YYYY-MM-DD") : null;
};

export const addressToLine = (addr) => {
  const c = addr?.company_address || {};
  return [
    c.address_line_1,
    c.address_line_2,
    c.address_line_3,
    addr?.location_name,
    addr?.district_name,
    addr?.state_name,
    addr?.pincode_name || addr?.pincode,
  ]
    .filter(Boolean)
    .join(", ");
};

export const splitName = (fullName) => {
  const parts = (fullName || "").trim().split(/\s+/).filter(Boolean);
  const firstname = parts.shift() || "";
  const lastname = parts.join(" ");
  return { firstname, lastname };
};
